export class PostPasswordForm {
  constructor() {
    const form = document.querySelector('.post-password-form')
    if (!form) return

    const input = form.querySelector('input[name="post_password"]')
    if (!input) return

    const toggle = document.createElement('button')
    toggle.type = 'button'
    toggle.className = 'post-password-form__toggle'
    toggle.textContent = 'Voir le mot de passe'
    toggle.setAttribute('aria-pressed', 'false')

    input.insertAdjacentElement('afterend', toggle)

    toggle.addEventListener('click', () => {
      const visible = input.type === 'text'
      input.type = visible ? 'password' : 'text'
      toggle.textContent = visible ? 'Voir le mot de passe' : 'Masquer le mot de passe'
      toggle.setAttribute('aria-pressed', String(!visible))
    })
  }
}
